<!--
 * @Author: Hyman Choi
 * @Date: 2021-01-21 15:24:29
 * @LastEditTime: 2021-09-02 17:49:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\appManagement\versionManagement\index.vue
-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 工具栏 -->
      <div class="topbar">
        <div>
          <el-input
            v-model="searchValue"
            placeholder=""
            size="small"
            prefix-icon="el-icon-search"
            class="search-input"
          />
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            :disabled="!searchValue"
            @click.stop="search()"
          >
            搜索
          </el-button>
          <el-button
            type="info"
            icon="el-icon-refresh"
            size="small"
            @click.stop="reset()"
          >
            重置
          </el-button>
        </div>
        <!-- <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="openAddExpertDialog()"
        >
          新增专家
        </el-button> -->
      </div>

      <!-- 内容 -->
      <el-table
        ref="table"
        v-loading="loading"
        :data="appVersionList"
        :header-cell-style="{ background: '#F5F7FA' }"
        style="width: 100%; margin-bottom: 20px"
      >
        <el-table-column
          label="ID"
          prop="UltraExpertID"
          width="100px"
          align="center"
        />
        <el-table-column
          label="versionCode"
          prop="versionCode"
          align="center"
        />
        <el-table-column
          label="versionName"
          prop="versionName"
          align="center"
        />
        <el-table-column
          label="updateLog"
          prop="updateLog"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column
          label="createTime"
          prop="createTime"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column
          label="downloadUrl"
          prop="downloadUrl"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column
          label="isForced"
          prop="isForced"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column
          label="useType"
          prop="useType"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column label="操作" width="150px" align="center">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="danger"
              @click.stop="deleteExpert(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        v-show="totalCount > pageSize"
        background
        layout="prev, pager, next"
        :total="totalCount"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="currentChange"
      />
    </el-card>
  </div>
</template>

<script>
import {
  getAppVersionList,
  getAppVersion,
  editAppVersion
} from '@/api/versionManagement'

export default {
  data() {
    return {
      loading: false, // 加载开关
      searchValue: '', // 搜索内容
      totalCount: 0, // 列表总数
      pageSize: 10, // 单页条数
      currentPage: 1, // 当前页码
      appVersionList: []
    }
  },
  created() {
    this.getAppVersionList()
    this.getAppVersion()
  },
  methods: {
    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage
      this.getAppVersionList()
    },
    /**
     * 获取所有版本列表
     */
    getAppVersionList() {
      const params = {
        Type: 0 // 0-Android，1-iOS
      }
      getAppVersionList(params).then(res => {
        this.appVersionList = res.resultData
        console.log('getAppVersionList:', res.resultData[0])
      })
    },
    /**
     * 获取最新版本信息
     */
    getAppVersion() {
      const params = {
        Type: 0 // 0-Android，1-iOS
      }
      getAppVersion(params).then(res => {
        console.log('getAppVersion:', res.resultData)
      })
    },
    /**
     * 修改版本信息
     */
    editAppVersion() {
      const data = {
        VersionName: '0.2.6',
        DownloadUrl: 'http://192.168.4.135/AppUpdate/Ultracloud_debug.apk',
        UpdateLog: '测试升级升级',
        Type: 0,
        IsForced: false,
        CompatibleCodes: '206,207'
      }
      editAppVersion(data).then(res => {
        console.log('editAppVersion:', res)
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
